import { Badge, Card, Center, Group, Stack, Text } from '@mantine/core'
import type { ReactNode } from 'react'

/** Равновесный блок-метрика. Используется и на дашборде, и в отчёте сотрудника. */
export function MetricBlock({
  icon,
  title,
  color,
  children,
}: {
  icon: ReactNode
  title: string
  color: string
  children: ReactNode
}) {
  return (
    <Card withBorder p="lg" radius="md" h="100%">
      <Group gap="xs" mb="md">
        <Badge color={color} variant="light" leftSection={icon} size="lg">
          {title}
        </Badge>
      </Group>
      {children}
    </Card>
  )
}

export function SubStat({
  label,
  value,
  sub,
  danger,
  muted,
}: {
  label: string
  value: string
  sub?: string
  danger?: boolean
  muted?: boolean
}) {
  return (
    <Stack gap={2} align="center">
      <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
        {label}
      </Text>
      <Text
        size="28px"
        fw={800}
        c={danger ? 'red.7' : muted ? 'dimmed' : undefined}
        style={{ fontFeatureSettings: '"tnum"' }}
      >
        {value}
      </Text>
      {sub && (
        <Text size="xs" c="dimmed">
          {sub}
        </Text>
      )}
    </Stack>
  )
}

/** Пустая выборка — «нет данных», НЕ NaN/0/пустой график. */
export function EmptyData({ text = 'Нет завершённых задач за период' }: { text?: string }) {
  return (
    <Center py="lg">
      <Text c="dimmed" size="sm">
        {text}
      </Text>
    </Center>
  )
}
